import React from 'react';
import WName from '../../../../WName';
import PL from '../../../../problems/ProblemLink';
import QL from '../../../../faq/QuestionLink';
import AL from '../../../../angles/AngleLink';
import NW from '../../../../neologisms/NewWord';
import OML from '../../../../ormaybe/OrMaybeLink';
import LRL from '../../../LongReadLink';
import {E1, E2, Qual, khorlo} from '../../../../common';

// ‘’ … –

export const imaginary = {
  name: "imaginary",
  alternatives: "i",
  prelude: <span>
    <WName cap ists /> like the <LRL>imagination</LRL>, but not <NW word="khorlo">{khorlo}</NW>. What about – in <AL name="fields.">maths</AL> – the ‘imaginary’ unit?
  </span>,
  header: <span>
    Deriving the ‘imaginary’ unit: <i>i</i> as an E<sub><i>n</i></sub>
  </span>,
  outside: <span>
    If E<sub><i>ω</i></sub> <PL name="form">represents</PL> –1 (minus one), it’s just finding the square root of <i>that</i>.
  </span>,
  preview: <div className="long-read-preview">
    <p>‘A string of <i>n</i> ones – in binary – <i>represents</i>,’ said <PL name="ch.">Amara</PL>, and there was a pause as <QL name="super-racist">hero</QL> scaly <NW>khet</NW> did what it ‘had to do’; if you’ve self-tormented with any of the other TormentPods you probably know what, but for the <QL>author</QL> it’s verboten kabisa to <PL name="ourself"><i>say</i> it</PL>, cf. <NW word="jorm">Jörmungandr</NW>. Sheo continued, ‘A  string of <i>n</i> ones is the positive number 2<sup><i>n</i></sup> – 1. E<sub><i>ω</i></sub> is the <i>limit</i> of 2<sup><i>n</i></sup> – 1 as <i>n</i> increases without bound. So you need something that <i>squares</i> to 2<sup><i>n</i></sup> – 1, and then take that to the limut.’</p>
    <p>‘So let’s calculate that,’ <PL name="ch.">Ishmael</PL> said. ‘Explicitly.’</p>
  </div>,
  text: <div className="long-read-text">
    <ul>
      <li>1111<sub>2</sub> (15<sub>10</sub>) = 
        101<sub>2</sub> (5<sub>10</sub>) ×
        11<sub>2</sub> (3<sub>10</sub>)</li>
      <li>111111<sub>2</sub> (63<sub>10</sub>) = 
        1001<sub>2</sub> (9<sub>10</sub>) ×
        111<sub>2</sub> (7<sub>10</sub>)</li>
      <li>11111111<sub>2</sub> (255<sub>10</sub>) = 
        10001<sub>2</sub> (17<sub>10</sub>) ×
        1111<sub>2</sub> (15<sub>10</sub>)</li>
      <li>1111111111<sub>2</sub> (1023<sub>10</sub>) = 
        100001<sub>2</sub> (33<sub>10</sub>) ×
        11111<sub>2</sub> (31<sub>10</sub>)</li>
      <li>…</li>
    </ul>
    <p>‘Clearly there’s one part where the limit is all ones and another where tthe limit is a one followed by infinite zeroes,’ <PL name="ch.">Rebecca</PL> said, coming by. ‘<QL name="super-racist">BI</QL> think that’s E<sub><i>ω</i></sub> and E<sub>1</sub>.’</p>
    <p>‘So minus one times one equals minus one,’ <PL name="ch.">Svitlana</PL> said. <QL name="super-racist">Shec</QL> sighed. ‘Yes, and true… but that’s not <i>squaring</i>.’</p>
    <p>‘No,’ Ishmael said, ‘but it’s a derivation of the necessary superpositions. The only way to represent it under this structure is – similar to how we do <LRL name="nepantla.sa.half">½ in binary</LRL> – is with two sets. For ½ you have to otake the average of the two numbers. For this, the numbers have to be multiplied togather when squared.’</p>
    <p>‘And we have just derived the “imaginary” unit <i>i</i> in SA,’ <PL name="seb">scaly</PL>-said Amara.</p>
  </div>,
};


